module.exports = __webpack_public_path__ + "icon_warning-af2b38fe580f274ca4c80479bd12141e.png";